import {Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-report-table-header',
  templateUrl: './report-table-header.component.html',
  styleUrls: ['./report-table-header.component.css'],
  standalone: false
})
export class ReportTableHeaderComponent implements OnInit {
  @Input() vm: any;
  @Input() isV2 = false;

  constructor() {
  }

  ngOnInit() {
  }

  getFilters() {
    if (!this.vm) {
      return [];
    }

    const data = this.isV2 ? this.vm.request : this.vm;
    if (!data) {
      return [];
    }

    const filters = [];

    if (data.dataType) {
      filters.push({label: $localize`:data@@data:data`, value: data.dataType});
    }
    if (data.includeUnposted) {
      filters.push({
        label: $localize`:includes@@includes:includes`,
        value: $localize`:Unposted Entries@@unpostedEntries:Unposted Entries`
      });
    }
    if (data.accountInput) {
      filters.push({label: $localize`:account@@account:account`, value: data.accountInput});
    }
    if (data.accountTypeName) {
      filters.push({
        label: $localize`:acct@@acct:acct` + ' ' + $localize`:type@@type:type`,
        value: data.accountTypeName
      });
    }
    if (data.accountSubtotalName) {
      filters.push({label: $localize`:subtotal@@subtotal:subtotal`, value: data.accountSubtotalName});
    }
    if (data.accountParentName) {
      filters.push({label: $localize`:parent@@parent:parent`, value: data.accountParentName});
    }
    if (data.bankName) {
      filters.push({label: $localize`:bank@@bank:bank`, value: data.bankName});
    }
    if (data.companyName) {
      filters.push({label: $localize`:co@@co:co`, value: data.companyName});
    }
    if (data.inventoryItemInput) {
      filters.push({label: $localize`:item@@item:item`, value: data.inventoryItemInput});
    }
    if (data.locationName) {
      filters.push({label: $localize`:loc@@loc:loc`, value: data.locationName});
    }
    if (data.currencyName) {
      filters.push({label: $localize`:cur@@cur:cur`, value: data.currencyName});
    }
    if (data.locationGroupName) {
      filters.push({
        label: $localize`:loc@@loc:loc` + ' ' + $localize`:group@@group:group`,
        value: data.locationGroupName || data.locationName
      });
    }
    if (data.entityInput) {
      filters.push({label: $localize`:entity@@entity:entity`, value: data.entityInput});
    }
    if (data.entityTypeName) {
      filters.push({
        label: $localize`:entity@@entity:entity` + ' ' + $localize`:type@@type:type`,
        value: data.entityTypeName
      });
    }
    if (data.entityCityName) {
      filters.push({
        label: $localize`:entity@@entity:entity` + ' ' + $localize`:city@@city:city`,
        value: data.entityCityName
      });
    }
    if (data.entityStateName) {
      filters.push({
        label: $localize`:entity@@entity:entity` + ' ' + $localize`:state@@state:state`,
        value: data.entityStateName
      });
    }

    // Handle RF fields
    const rfType = this.isV2 ? this.vm.request?.rfType : this.vm.rfType;
    if (rfType && Array.isArray(rfType)) {
      for (let i = 0; i < 5; i++) {
        const rfName = data[`rf${i + 1}Name`];
        if (rfName && rfType[i]) {
          filters.push({label: rfType[i].name.toLowerCase(), value: rfName});
        }
      }
    }

    return filters;
  }
}
